<h3>Event Schedules</h3>
<app-dc-alert-inner></app-dc-alert-inner>
<form class="form-row form-group" [formGroup]="form">
  <div class="form-group col-lg-12 col-min form-row d-flex">
    <div class="col-lg-4">
      <app-dc-select 
        formControlName="scheduleStrategy"
        [label]="labels.summary.scheduleStrategy"
        [items]="scheduleStrategyItems"
        [closeOnSelect]="true"
        [clearSelection]="true">
      </app-dc-select>
    </div>
    <div class="col-lg-3 col-min d-flex get-schedules">
      <button
        type="button"
        class="btn btn-primary btn-sm d-flex"
        [disabled]="isRefreshing || !canUserEdit"
        (click)="getSchedules()"
      >
        <span class="spinner mr-1">
          <span
            *ngIf="isRefreshing"
            aria-hidden="true"
            class="spinner-border spinner-border-sm"
            role="status"
          >
          </span>
        </span>
        <span>Create Schedules</span>
      </button>
    </div>
  </div>
  <div class="col-lg-12">
    <app-key-dates-data></app-key-dates-data>
  </div>
</form>

<ng-container *ngIf="productForm && schedulesVisibility">
  <app-coupon-schedule
    #couponScheduleRef
    *ngIf="schedulesVisibility.coupon()"
    [isRefreshing]="isRefreshing"
    (rowUpdated)="updateProductData(couponScheduleRef)"
    (scheduleTypeChanged)="applyScheduleStrategyDefaultValue()"
    [isEditing]="isEditing"
    [canUserEdit]="canUserEdit"
    [productForm]="productForm"
    [product]="product"
  >
  </app-coupon-schedule>
  <app-call-schedule
    *ngIf="schedulesVisibility.earlyRedemption()"
    #callabilityScheduleRef
    [isRefreshing]="isRefreshing"
    [canUserEdit]="canUserEdit"
    (rowUpdated)="updateProductData(callabilityScheduleRef)"
    [isEditing]="isEditing"
    [productForm]="productForm"
    [product]="product"
  >
  </app-call-schedule>
  <app-participation-schedule
    #participationScheduleRef
    *ngIf="schedulesVisibility.participation()"
    [isEditing]="isEditing"
    [productForm]="productForm"
    [product]="product"
    style="display: none">
  </app-participation-schedule>
</ng-container>